import { Role, VisibleRole } from 'types/company/access';
import { CommunityConfiguration, CommunityInviteAs, CommunityType } from 'types/company/community';

const advisorLabel = (configuration?: CommunityConfiguration) => configuration?.advisorRoleName ?? 'Advisor';

export const communityInvitedAsDisplayName = (
  invitedAs: CommunityInviteAs,
  _communityId: number,
  configuration?: CommunityConfiguration,
) => {
  switch (invitedAs) {
    case 'Admin':
    case 'Employee':
    case 'Investor':
    case 'Mentor':
      return invitedAs;
    case 'Company':
      return 'Start-up or Scale-up';
    case 'Organization':
      return 'Corporate or Organization';
    case 'Advisor':
      return advisorLabel(configuration);
    case 'NotSpecified':
      return 'Member chooses';
  }
};

export const communityRoleDisplayName = (role: Role, _communityId: number, configuration?: CommunityConfiguration) => {
  switch (role) {
    case 'company_master':
    case 'organization_master':
      return 'Admin';
    case 'board':
      return 'Board member';
    case 'investor':
      return 'Investor';
    case 'employee':
      return 'Employee';
    case 'prospective_investor':
      return 'Follower';
    case 'advisor':
      return advisorLabel(configuration);
    case 'mentor':
      return 'Mentor';
    case 'company_admin_in_community':
      return 'Company admin';
    case 'organization_admin_in_community':
      return 'Organization admin';
  }
};

export const invisibleRoles: Role[] = ['company_admin_in_community', 'organization_admin_in_community'];

export const communityRoles = (
  communityType: CommunityType | undefined,
  configuration?: CommunityConfiguration,
): VisibleRole[] => {
  const hasBoardRoom = configuration?.hasBoardRoom === true;
  if (communityType === 'investor_arena' && hasBoardRoom)
    return ['company_master', 'advisor', 'board', 'employee', 'investor', 'mentor'];
  if (communityType === 'investor_arena' && !hasBoardRoom)
    return ['company_master', 'advisor', 'employee', 'investor', 'mentor'];
  if (communityType === 'mentor_network') return ['company_master', 'mentor'];
  if (communityType === 'mentor_master_network') return ['company_master'];
  else return ['company_master', 'advisor', 'board', 'investor', 'employee'];
};

/**
 * Like communityRoles, but also respects Application Community restrictions.
 * Application Communities (companyApplicationIsEnabled) only support a subset of roles.
 * Use this instead of communityRoles anywhere users can be assigned roles directly.
 */
export const assignableRoles = (
  communityType: CommunityType | undefined,
  configuration?: CommunityConfiguration,
): VisibleRole[] => {
  if (configuration?.companyApplicationIsEnabled) {
    return ['company_master', 'advisor'];
  }
  return communityRoles(communityType, configuration);
};
